module.exports = __webpack_public_path__ + "1.5.0-unryo/img/azure.ee4e4bf0.svg";